import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { axios } from '../hooks/useAuth';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    axios.get(`/api/auth/verify-email/${token}`)
      .then(res => { setStatus('success'); setMessage(res.data.message); })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.error || 'Verification failed'); });
  }, [token]);

  return (
    <div className="page page-enter" style={{ maxWidth: 480, textAlign: 'center', paddingTop: 80 }}>
      {status === 'loading' && (
        <>
          <div style={{ fontSize: 48 }} className="animate-float">🔄</div>
          <h2 style={{ marginTop: 16 }}>Verifying your email...</h2>
        </>
      )}
      {status === 'success' && (
        <>
          <div style={{ fontSize: 64 }} className="animate-float">✅</div>
          <h2 className="gradient-text" style={{ marginTop: 16, fontSize: 28 }}>Email Verified!</h2>
          <p className="text-secondary" style={{ margin: '12px 0 28px' }}>{message}</p>
          <Link to="/login" className="btn btn-primary btn-lg">🎤 Sign In Now</Link>
        </>
      )}
      {status === 'error' && (
        <>
          <div style={{ fontSize: 64 }}>❌</div>
          <h2 style={{ marginTop: 16 }}>Verification Failed</h2>
          <p className="text-muted" style={{ margin: '12px 0 28px' }}>{message}</p>
          <Link to="/register" className="btn btn-secondary">Try registering again</Link>
        </>
      )}
    </div>
  );
}
